import { useCosignatureQueue } from "@/features/cosignature/api/queries/useCosignatureQueue";

import { CosignatureTable } from "../(table)/CosignatureTable";
import { Filters } from "../(filters)/Filters";

import type { CosignatureFilterControls } from "./CosignaturePanel";

type AllNotesPanelProps = {
  filters: CosignatureFilterControls;
  onClearFilters?: VoidFunction;
};

// owns its query — the panel only mounts when the All Notes tab is selected,
// so the fetch is naturally lazy without a tab-state gate
export function AllNotesPanel({ filters, onClearFilters }: AllNotesPanelProps) {
  const { data, isLoading } = useCosignatureQueue({
    searchParams: {
      cosignature_status: filters.status ?? undefined,
      supervisor_id: filters.supervisor_id ?? undefined,
    },
  });

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <Filters tab="all-notes" {...filters} />

      <CosignatureTable data={data} isLoading={isLoading} onClearFilters={onClearFilters} />
    </div>
  );
}
